import React, { useRef } from "react";
import { getFromStorage, setInStorage } from "../../utils/storage";
import renderHTML from "react-render-html";
import { Button } from "@material-ui/core";
import axios from "axios";
import api from "../../config/api.json";
import { toast } from "react-toastify";

const View = () => {
  const image = getFromStorage("View") && getFromStorage("View").image;
  const html = getFromStorage("View") && getFromStorage("View").html;
  const case_id = getFromStorage("View") ? getFromStorage("View").case_id : "";
  const componentRef = useRef();

  //Error notification
  const notifyError = error => {
    toast.error("" + error.toString());
  };

  //download dicom
  const downloadDicom = () => {
    const body = {
      task: "downloadDicom",
      case_id
    }
    const headers = {
      "Content-Type": "application/json"
    }

    axios.post(api.postMethodURL, body, headers)
    .then(res => {
      if(!res.data.errorMessage){
        window.location = res.data;
      }
    })
    .catch(err => {
      notifyError(err.toString());
    })
  }

  if(getFromStorage("View")){
    return (
      <div
        style={{
          paddingTop: "90px",
          paddingLeft: "80px",
          paddingRight: "20px",
          backgroundColor: "white",
          paddingBottom: "70px",
        }}
      >
        <section
          ref={componentRef}
          style={{
            paddingTop: "30px",
            paddingLeft: "10px",
            paddingRight: "10px"
          }}
        >
          <h3
            style={{
              paddingLeft: "10px",
              paddingRight: "10px",
              paddingBottom: "20px",
              backgroundColor: "white"
            }}
          >
            View Case
          </h3>
          <div style={{ textAlign: "center" }}>
            <img
              src={`data:image/png;base64,${image}`}
              alt=""
              height={300}
              style={{ cursor: "pointer" }}
              onClick={() => {
                window.open("/#/Image");
              }}
            />
          </div>
          <br />
          <br />
          {renderHTML(html)}
          <br />
          <br />
        </section>
        <div style={{ textAlign: "center" }}>
          <Button variant="outlined" size="small" color="primary" style={{textTransform: "none", margin: "10px"}} onClick={downloadDicom}>
            Download Dicom
          </Button>
          <Button
            variant="contained"
            color="secondary"
            size="small"
            style={{textTransform: "none", margin: "10px"}}
            onClick={() => {
              setInStorage("html", html);
              window.open("/#/Html");
            }}
          >
            Print
          </Button>
        </div>
      </div>
    );
  } else {
    return <div style={{textAlign:"center"}}>Nothing Available</div>
  }
};
export default View;
